import { InjectionToken } from "@angular/core";

export class AppConfig {
  urlApi: string
}

export let APP_CONFIG = new InjectionToken<AppConfig>('APP_CONFIG')
